import axios from "axios";
import Vue from "vue";
import AWS from "aws-sdk";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({}),

  actions: {
    //TODO: load, update, create
    cacheReset: (context, request) => {
      return axios
        .delete(context.getters.getTmsServiceUrl + "/cache")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    testApi: (context, request) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/train/create-scheduled-trains")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    createSelectedSefers: (context, seferNumber) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/train/create-single-schedule-trains/" + seferNumber)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
};
